import { useTranslation } from 'react-i18next';
import { useGenericMutation } from '@hooks/use-generic-mutation';
import { useToast } from '@hooks/use-toast/use-toast';
import { useQueryClient } from '@tanstack/react-query';
import { request } from '@utils/request/request';
import { RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS as ADMISSIONS_PRESET_QUERY_KEYS } from '../admissions/constants';

import { QUERY_KEYS } from './constants';

const deleteFloorplan = async (floorplanId: string) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/floorplan-presets/${floorplanId}`;

  return request({ url, method: RequestMethod.DELETE });
};

export const useDeleteFloorplanPreset = () => {
  const { t } = useTranslation();
  const toast = useToast();
  const queryClient = useQueryClient();

  return useGenericMutation(
    [QUERY_KEYS.deleteFloorplanPreset],
    async ({ floorplanId }: { floorplanId: string }) => deleteFloorplan(floorplanId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.getFloorplanPresets] });
        queryClient.invalidateQueries({ queryKey: [ADMISSIONS_PRESET_QUERY_KEYS.getAdmissionsPresets] });

        toast.push({
          title: t('offers:deletedOfferSuccessNotificationTitle'),
          text: '',
          type: 'success',
        });
      },
    }
  );
};
